import { makeAutoObservable } from "mobx";

class SurveysUiStore {
  activeTab = "standard";

  standardDeleteTarget = null;
  standardDeleteLoading = false;

  customDeleteTarget = null;
  customDeleteLoading = false;

  responsesDeleteTarget = null;
  responsesDeleteLoading = false;

  constructor() {
    makeAutoObservable(this);
    if (typeof window !== "undefined") {
      const stored = window.localStorage.getItem("nxSurveyActiveTab");
      if (stored) this.activeTab = stored;
    }
  }

  setActiveTab = (value) => {
    this.activeTab = value;
    if (typeof window !== "undefined") {
      window.localStorage.setItem("nxSurveyActiveTab", value);
    }
  };

  openStandardDelete = (survey) => {
    this.standardDeleteTarget = survey;
  };

  closeStandardDelete = () => {
    this.standardDeleteTarget = null;
    this.standardDeleteLoading = false;
  };

  setStandardDeleteLoading = (value) => {
    this.standardDeleteLoading = value;
  };

  openCustomDelete = (survey) => {
    this.customDeleteTarget = survey;
  };

  closeCustomDelete = () => {
    this.customDeleteTarget = null;
    this.customDeleteLoading = false;
  };

  setCustomDeleteLoading = (value) => {
    this.customDeleteLoading = value;
  };

  openResponsesDelete = (response) => {
    this.responsesDeleteTarget = response;
  };

  closeResponsesDelete = () => {
    this.responsesDeleteTarget = null;
    this.responsesDeleteLoading = false;
  };

  setResponsesDeleteLoading = (value) => {
    this.responsesDeleteLoading = value;
  };
}

export const surveysUiStore = new SurveysUiStore();
